import { createRouter, createWebHistory } from 'vue-router';

//测试
const Test = () => import('@/views/test/test.vue');
const VolkswagenTmp = () => import('@/views/temp/volkswagen.vue');

const Home = () => import('@/views/home/home.vue');
const SkinSwap = () => import('@/views/skinSwap/skinSwap/skinSwap.vue');
const PaintSelector = () => import('@/views/skinSwap/paintSelector/paintSelector.vue');
const Works = () => import('@/views/works/works/works.vue');
const WorksSearch = () => import('@/views/works/worksSearch/worksSearch.vue');
const WorksFilter = () => import('@/views/works/worksFilter/worksFilter.vue');
const WorksDetail = () => import('@/views/works/worksDetail/worksDetail.vue');
const Mine = () => import('@/views/mine/mine/mine.vue');
const Login = () => import('@/views/mine/login/login.vue');
const PersonalBio = () => import('@/views/mine/personalBio/personalBio.vue');
const AccountSetting = () => import('@/views/mine/accountSetting/accountSetting.vue');
const ChangePassword = () => import('@/views/mine/changePassword/changePassword.vue');
const Favorites = () => import('@/views/mine/favorites/favorites.vue');
const Creations = () => import('@/views/mine/creations/creations/creations.vue');
const UploadWorks = () => import('@/views/mine/creations/uploadWorks/uploadWorks.vue');
const AuthorProfile = () => import('@/views/mine/authorProfile/authorProfile.vue');
const BrandZone = () => import('@/views/brandZone/brandZone/brandZone.vue');
const Aito = () => import('@/views/brandZone/aito/aito.vue');
const Volkswagen = () => import('@/views/brandZone/volkswagen/volkswagen/volkswagen.vue');
const VolkswagenPlan = () => import('@/views/brandZone/volkswagen/plan/plan.vue');
const Benz = () => import('@/views/brandZone/benz/benz.vue');
const bPillarStickersInstallGuide = () => import('@/views/installGuide/bPillarStickers/bPillarStickers.vue');
const Store = () => import('@/views/store/store.vue');
const ThreeDBrand = () => import('@/views/3DModel/brand/brand.vue');
const ThreeDSkin = () => import('@/views/3DModel/skin/skin.vue');

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            keepAlive: true,
            showMobileNavbar: true,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: false
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/brand-zone',
        name: 'BrandZone',
        component: BrandZone,
        meta: {
            keepAlive: false,
            showMobileNavbar: true,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/brand/volkswagen',
        name: 'Volkswagen',
        component: Volkswagen,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: false,
            showDevelopNavbar: true,
            showDevelopFooter: false
        }
    },
    {
        path: '/brand/volkswagen-plan',
        name: 'VolkswagenPlan',
        component: VolkswagenPlan,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: false,
            showDevelopNavbar: true,
            showDevelopFooter: false
        }
    },
    {
        path: '/brand/aito',
        name: 'Aito',
        component: Aito,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/brand/benz',
        name: 'Benz',
        component: Benz,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/skin-swap',
        name: 'SkinSwap',
        component: SkinSwap,
        meta: {
            keepAlive: false,
            showMobileNavbar: true,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/paint-selector',
        name: 'PaintSelector',
        component: PaintSelector,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/works',
        name: 'Works',
        component: Works,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/works-search',
        name: 'WorksSearch',
        component: WorksSearch,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/works-filter',
        name: 'WorksFilter',
        component: WorksFilter,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/works-detail',
        name: 'WorksDetail',
        component: WorksDetail,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/mine',
        name: 'Mine',
        component: Mine,
        meta: {
            keepAlive: false,
            showMobileNavbar: true,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/personal-bio',
        name: 'PersonalBio',
        component: PersonalBio,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/account-setting',
        name: 'AccountSetting',
        component: AccountSetting,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/change-password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/favorites',
        name: 'Favorites',
        component: Favorites,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/creations',
        name: 'Creations',
        component: Creations,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/upload-works',
        name: 'UploadWorks',
        component: UploadWorks,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/author-profile',
        name: 'AuthorProfile',
        component: AuthorProfile,
        meta: {
            keepAlive: true,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/b-pillar-stickers-install-guide',
        name: 'bPillarStickersInstallGuide',
        component: bPillarStickersInstallGuide,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/store',
        name: 'Store',
        component: Store,
        meta: {
            keepAlive: false,
            showMobileNavbar: true,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: true
        }
    },
    {
        path: '/test',
        name: 'Test',
        component: Test,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: false,
            showDevelopNavbar: false,
            showDevelopFooter: false
        }
    },
    {
        path: '/tmp/volkswagen',
        name: 'VolkswagenTmp',
        component: VolkswagenTmp,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: false,
            showDevelopNavbar: false,
            showDevelopFooter: false
        }
    },
    {
        path: '/3d/brand',
        name: 'ThreeDBrand',
        component: ThreeDBrand,
        meta: {
            keepAlive: true,
            showMobileNavbar: true,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: false
        }
    },
    {
        path: '/3d/skin/:id?',
        name: 'ThreeDSkin',
        component: ThreeDSkin,
        meta: {
            keepAlive: false,
            showMobileNavbar: false,
            showMobileToolbar: true,
            showDevelopNavbar: true,
            showDevelopFooter: false
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    if (from.query.type === 'iframe' && !to.query.type) {
        next({ ...to, query: { ...to.query, type: 'iframe' } });
        return;
    }

    if (to.query.type === 'iframe') {
        to.meta.showMobileNavbar = false;
        to.meta.showMobileToolbar = false;
        to.meta.showDevelopNavbar = false;
        to.meta.showDevelopFooter = false;
    }
    next();
});

export default router;